<template>
  <section class="menu" id="main_menu">
    <BtnBack class="back" v-if="$route.name !== 'Home'" />
    <div
      class="menu__wrapper"
      :class="$route.name !== 'Home' ? 'layout-menu' : ''"
    >
      <h2 class="title">Оберіть меню</h2>
      <div class="menu-container">
        <div
          class="menu__item"
          v-for="(item, index) in productsMenu"
          :key="index"
        >
          <img
            class="menu-icon"
            :class="$route.name !== 'Home' ? 'menu-icon-layout' : ''"
            :src="require(`@/assets/images/main_menu/${item.src}`)"
            :alt="item.name"
          />
          <button class="btn-main btn--reverse " @click="selectMenu(item.href)">
            {{ item.name }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import BtnBack from "@/components/BtnBack.vue";
export default {
  name: "BlockMainMenu",
  data() {
    return {};
  },
  computed: mapGetters(["productsMenu"]),
  components: {
    BtnBack,
  },
  methods: {
    selectMenu(flag) {
      if (flag !== "/sushi_menu") {
        this.$router.push("/menu" + flag);
      } else {
        this.$router.push({ path: flag });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.menu {
  background: url("~@/assets/images/sushi_pizza_background2.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-flow: nowrap;
  position: relative;
}
.menu-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-flow: wrap;
  max-width: 1250px;
  margin: 0 auto;
  justify-content: center;
}
.menu__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 0 33%;
}
.menu-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  place-content: space-around;
}
.menu__wrapper {
  background: #000000e0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15vh 0 25vh;
}
.menu-icon {
  margin-top: 10vh;
  height: 200px;
  max-width: 100%;
}
.menu-icon-layout {
  margin-top: 5vh;
}
.pasta_menu {
  // width: 300px;
}
.free_menu {
  // width: 220px;
  // padding: 0 10vh;
}

.menu__wrapper .title {
  color: white;
  font-family: sans-serif;
  font-size: 2em;
}
.layout-menu {
  padding: 7vh 0 12vh;
}
.back {
  top: 120px;
}

@media only screen and (max-width: 767px) {
  .back {
    margin-top: 2vh;
  }
  .menu__wrapper {
    padding: 5vh 2px 15vh;
  }
  .menu-row {
    flex-direction: column;
    width: 100%;
    place-content: space-around;
  }
  .menu__item {
    flex: 0 0 100%;
  }
  .menu-icon {
    margin-top: 5vh;
  }
}
@media (min-width: 768px) and (max-width: 850px) {
}
@media (min-width: 851px) {
}
</style>
